import { render, staticRenderFns } from "./LandGHomeCard.vue?vue&type=template&id=cfd2ef8e"
import script from "./LandGHomeCard.vue?vue&type=script&lang=js"
export * from "./LandGHomeCard.vue?vue&type=script&lang=js"
import style0 from "./LandGHomeCard.vue?vue&type=style&index=0&id=cfd2ef8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports